import React from "react";
import { array, func, bool, string } from "prop-types";
import { chunk } from "lodash";

import LoadMore from "../../atoms/loadmore";
import TwelveStoryMixedDesign from "../twelve-story-mixed-design";

import translate from "../../translate";

import "./moreCollectionStories.m.css";

const MoreCollectionStories = (
  { stories, onLoadMore, noMoreStories, loading, publisherName },
  NO_OF_ITEMS_LOAD,
  setLoading
) => {
  const list = chunk(stories, 12);
  const isMoreStories = NO_OF_ITEMS_LOAD <= stories.length && !noMoreStories;

  if (setLoading) {
    setLoading(loading);
  }

  return (
    <React.Fragment>
      <div styleName="story-list">
        {list.map((itemList, index) => (
          <TwelveStoryMixedDesign
            key={index}
            list={itemList}
            className={isMoreStories && index + 1 === list.length ? "twelve-story-mixed-design" : ""}
          />
        ))}
      </div>

      {isMoreStories && <LoadMore onClick={onLoadMore} content={translate(publisherName, "load_more")} />}
    </React.Fragment>
  );
};

MoreCollectionStories.propTypes = {
  stories: array,
  onLoadMore: func,
  noMoreStories: bool,
  loading: bool,
  publisherName: string,
};

export default MoreCollectionStories;
